/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
function submitContactForm( e ) {
    e.preventDefault();
    const form = e.target;

    let data = {
        'action': 'submit_contact_form',
    };
    for ( let i = 0; i < form.elements.length; i++ ) {
        const element = form.elements[ i ];
        if ( element.name ) {
            data[ element.name ] = element.value;
        }
    }

    const recaptchaKey = form.getAttribute( 'data-recaptcha' );
    if ( !recaptchaKey ) {
        console.error( 'No reCAPTCHA key provided' );
        if ( 'undefined' !== typeof hemisBuildLightbox ) {
            hemisBuildLightbox( 'Une erreur est survenue, le captcha n\'a pas pu être chargé.' );
        } else {
            alert( 'Une erreur est survenue, le captcha n\'a pas pu être chargé.' );
        }
        return false;
    }

    const ajax_url = form.getAttribute( 'data-ajax_url' );
    if ( !ajax_url ) {
        console.error( 'No AJAX URL provided' );
        if ( 'undefined' !== typeof hemisBuildLightbox ) {
            hemisBuildLightbox( 'Une erreur est survenue, le formulaire de contact n\'a pas pu être soumis.' );
        } else {
            alert( 'Une erreur est survenue, le formulaire de contact n\'a pas pu être soumis.' );
        }
        return false;
    }
    
    // On exécute recaptcha
    grecaptcha.ready( function () {

        // On va chercher le token
        grecaptcha.execute( recaptchaKey, { action: 'contact' } ).then( function ( token ) {

            // On ajoute le token au formulaire
            data[ 'recaptcha_token' ] = token;

            // On envoie le formulaire
            fetch( ajax_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: new URLSearchParams( data )
            } )
            .then( response => response.json() )
            .then( response => {
                if ( response.success ) {
                    form.reset();
                    if ( 'undefined' !== typeof hemisBuildLightbox ) {
                        hemisBuildLightbox( response.data.message );
                    } else {
                        alert( response.data.message );
                    }
                } else {
                    if ( 'undefined' !== typeof hemisBuildLightbox ) {
                        hemisBuildLightbox( response.data.message );
                    } else {
                        alert( response.data.message );
                    }
                }
            } )
            .catch( error => {
                console.error( 'Error:', error );
                if ( 'undefined' !== typeof hemisBuildLightbox ) {
                    hemisBuildLightbox( 'Une erreur est survenue lors de la soumission du formulaire.' );
                } else {
                    alert( 'Une erreur est survenue lors de la soumission du formulaire.' );
                }
            } );
        } );
    } );

    return false;
}

const initializeContactForm = () => {
    const forms = document.querySelectorAll( '.wp-block-hemis-blocks-contact-form form' );
    forms.forEach( form => {
        form.addEventListener( 'submit', submitContactForm );
    } );
}

document.addEventListener( 'DOMContentLoaded', initializeContactForm );